import React, {useState} from 'react';
import s from './TableElements.module.css';
import TableFullViewProductEl from './TableFullViewProductEl';
import {OrdersType} from '../../../types/TypesStore';
import {useTranslation} from 'react-i18next';
import InvoiceActions from '../../../PersonalOffice/ListOfInvoices/components/InvoiceActions';
import {
	deliveryStatusTranslate,
	invoiceStatusTranslate,
} from '../../../assets/utils/translatersFunc';

type Props = {
	data: OrdersType;
	index: number;
};
const InvoiceTableRowEl: React.FC<Props> = ({data, index}) => {
	const [openOrder, setOpenOrder] = useState<number | null>(null);
	const active = openOrder === index;

	const handleClickOpen = () => {
		setOpenOrder(openOrder !== index ? index : null);
	};
	const {t} = useTranslation();

	const isOutcomeOrWriteOff =
		data.type === 'outcome' || data.type === 'write-off';

	return (
		<>
			<div
				className={`${s.productRowContainer} ${isOutcomeOrWriteOff ? s.grayRow : ''}`}
			>
				<div
					className={`${s.productRowcolumn} ${s.idColumn}`}
					onClick={handleClickOpen}
				>
					<div
						className={`shopping__item shopping__1 shopping__1-1 ${active && 'active'}`}
					>
						{' '}
					</div>
					<div>{data.id}</div>
				</div>
				<div
					className={`${s.productRowcolumn}`}
					title={`${t('Дата проведення')}: ${data.order_date}`}
				>
					{data.create_date ? data.create_date.slice(0, 10) : ''}
				</div>
				<div className={`${s.productRowcolumn}`}>
					{deliveryStatusTranslate(data?.delivery_type ?? '')}
				</div>
				<div className={`${s.productRowcolumn}`}>
					{invoiceStatusTranslate(data.status)}
				</div>
				<div
					className={`${s.productRowcolumn} ${s.ttnColumn}`}
					title={
						data.delivery_date
							? `${t('Час доставки')}: ${data.delivery_date}`
							: ''
					}
				>
					{data.post_id}
				</div>
				<div className={`${s.productRowcolumn}`}>
					<InvoiceActions order={data} />
				</div>
			</div>
			<TableFullViewProductEl order={data} active={active} />
		</>
	);
};

export default InvoiceTableRowEl;
